export const SHOW_PLUGINS = 'Plugins';
export const SHOW_THEMES = 'Themes';
export const SHOW_TEMPLATES = 'Templates';



/** WEBPACK FOOTER **
 ** ./client/constants/CategoryFilters.ts
 **/